import { render, staticRenderFns } from "./ShareButtonGroup.vue?vue&type=template&id=283016f8&"
import script from "./ShareButtonGroup.vue?vue&type=script&lang=js&"
export * from "./ShareButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports